// SPDX-License-Identifier: AGPL-3.0-or-later
import { addDays, daysInMonth, isoDate, monthOf, yearOf, type IsoDate } from "@almanac/domain";

/**
 * The one keyboard map for both calendar views: arrows move by day and
 * week, Page Up/Down by month, Home/End to the month's first and last day.
 * Movement stays inside `year` when given. Returns null for other keys.
 */
export function moveDate(date: IsoDate, key: string, year?: number): IsoDate | null {
  const y = yearOf(date);
  const m = monthOf(date);
  const d = Number(date.slice(8, 10));
  let next: IsoDate;
  switch (key) {
    case "ArrowLeft":
      next = addDays(date, -1);
      break;
    case "ArrowRight":
      next = addDays(date, 1);
      break;
    case "ArrowUp":
      next = addDays(date, -7);
      break;
    case "ArrowDown":
      next = addDays(date, 7);
      break;
    case "PageUp": {
      const pm = m === 1 ? 12 : m - 1;
      const py = m === 1 ? y - 1 : y;
      next = isoDate(py, pm, Math.min(d, daysInMonth(py, pm)));
      break;
    }
    case "PageDown": {
      const nm = m === 12 ? 1 : m + 1;
      const ny = m === 12 ? y + 1 : y;
      next = isoDate(ny, nm, Math.min(d, daysInMonth(ny, nm)));
      break;
    }
    case "Home":
      next = isoDate(y, m, 1);
      break;
    case "End":
      next = isoDate(y, m, daysInMonth(y, m));
      break;
    default:
      return null;
  }
  if (year === undefined) return next;
  if (yearOf(next) < year) return isoDate(year, 1, 1);
  if (yearOf(next) > year) return isoDate(year, 12, 31);
  return next;
}
